export { default } from "./Users";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-admin/Users/index.js